export default __webpack_public_path__ + "static/media/Group.9eead1d8.png";